import React, { useState } from "react";
import {
  Box,
  Stack,
  Typography,
  IconButton,
  OutlinedInput,
  InputAdornment,
  Button,
  CircularProgress,
} from "@mui/material";
import { Camera } from "react-iconly";
import { Images } from "./../../assets/common";
import ApiService from "./../../services/api-service";
import {
  copyToClipboard,
  generateDynamicLink,
  fullName,
  getErrorString,
  isEmpty,
  matchYoutubeUrl,
  onShare,
  putRecors,
} from "./../../constants/function";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useHistory } from "react-router-dom";
import notifier from "./../../components/Notifier";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import UploadIcon from "@mui/icons-material/Upload";
import CloseIcon from "@mui/icons-material/Close";
import Loader from "../Loader";
import IosShareIcon from "@mui/icons-material/IosShare";
import ProfileMenu from "../ProfileMenu";
import OutsideClickHandler from "react-outside-click-handler";
import { useTranslation } from "react-i18next";
import "./index.scss";
import HexagonBar from "../HexagonProgressBar";
import HexagonalProgress from "../HexagonalProgress";
import { isOwnerId, isOwner } from "../../constants/function";

export default function ProfileBanner(props) {
  const { t } = useTranslation("common");
  const [videoLoader, setVideoLoader] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [upload, setUpload] = useState(false);
  const history = useHistory();
  const [image, setImage] = useState(Images.default_user);
  const [cover, setCover] = useState(Images.default_cover);
  const [option, setOption] = React.useState(false);

  function onFileChooser(id) {
    document.getElementById(id).click();
  }

  const onFileSelect = async (e, type) => {
    imageHandler(e.target.files[0], type);
  };

  async function imageHandler(e, type) {
    if (e && e["name"]) {
      var accept = [
        "png",
        "jpg",
        "jpeg",
        "gif",
        "image/png",
        "image/gif",
        "image/jpg",
        "image/jpeg",
      ];
      var extension = e["name"].split(".").pop().toLowerCase(); //file extension from input file
      var isSuccess = accept.indexOf(extension) > -1; //is extension in acceptable types
      if (isSuccess) {
        const reader = new FileReader();
        reader.onload = async function () {
          if (reader.readyState === 2) {
            if (type === "profileImg") setImage(reader.result);
            else setCover(reader.result);
            handleSaveChanges(e, type);
          }
        };
        reader.readAsDataURL(e);
      } else {
        notifier.error(t("notifier.error.toast14"));
      }
    }
  }

  //TODO: update user profile pic
  async function handleSaveChanges(f, type) {
    // CommonUtilityService.showLoader();

    const formData = new FormData();
    const imgsize = f.size / 1024;
    if (imgsize > 6144 && type !== "coverImg") {
      notifier.error(t("notifier.error.toast12"));
      document.getElementById("profileImg").value = "";
      return;
    } else if (imgsize < 20 && type !== "coverImg") {
      notifier.error(t("notifier.error.toast13"));
      document.getElementById("profileImg").value = "";
      return;
    }
    if (imgsize > 6144 && type === "coverImg") {
      notifier.error(t("notifier.error.toast12"));
      document.getElementById("coverImg").value = "";
      return;
    }
    props.loader(true);
    formData.append(
      type === "profileImg" ? "profileImg" : "coverImg",
      f,
      f.name
    );

    try {
      const response = await ApiService.UPDATE_USER(formData);
      props.loader(false);
      props.onUpdate(response["result"]);
    } catch (error) {
      props.loader(false);
      notifier.error(getErrorString(error));
    }
  }

  React.useEffect(() => {
    if (document.getElementById("outerBox")) {
      document.getElementById("outerBox").style.paddingTop = "0";
    }
    return () => {
      if (document.getElementById("outerBox")) {
        document.getElementById("outerBox").style.paddingTop = "16px";
      }
    };
  }, []);
  const handleCopy = async (action) => {
    const userData = props.userData;
    const title = userData.userName || `${userData.firstName} ${userData.lastName}`;
    const url = await generateDynamicLink('profile', userData._id, title, userData.profileImg?.filePath);

    switch (action) {
      case "m14":
        copyToClipboard(url);
        notifier.info("link copied");
        break;
      case "m15":
        onShare(action, url, {
          id: props?.userData._id,
          referralLink: url,
          eventType: ["sharedOutbound"],
          eventAsset: props?.userData._id,
          sharedBy: fullName(props?.userData),
          eventValue: ["Profile"],
          socialMedia: "facebook",
        });
        break;
      case "m16":
        onShare(action, url, {
          id: props?.userData._id,
          referralLink: url,
          eventType: ["sharedOutbound"],
          eventAsset: props?.userData._id,
          sharedBy: fullName(props?.userData),
          eventValue: ["Profile"],
          socialMedia: "twitter",
        });
        break;
      case "Share on Instagram":
        onShare(action, url);
        break;

      default:
        break;
    }
  };
  const handleUpload = async () => {
    if (videoUrl.trim() !== "" && !videoLoader) {
      const isValid = matchYoutubeUrl(videoUrl);
      if (!isValid) {
        notifier.error("invalid url");
        return;
      }
      try {
        setVideoLoader(true);
        const response = await ApiService.UPLOAD_VIDEO({
          url: videoUrl,
        });
        setVideoLoader(false);

        setVideoUrl("");
        setUpload(false);
        notifier.success("video uploaded");
      } catch (error) {
        setVideoLoader(false);
        notifier.error(getErrorString(error));
      }
    }
  };
  const handleClick = (event) => {
    setOption(!option);
    if (window.location.href.includes("referralId="))
      putRecors({
        id: props?.userData._id,
        referralLink: window.location.href,
        eventType: ["click"],
        eventAsset: props?.userData._id,
        sharedBy: fullName(props?.userData),
        eventValue: ["Profile"],
        socialMedia: null,
      });
  };
  const handleClose = () => {
    setOption(false);
  };
  return (
    <Box position="relative" sx={{ height: "45vh" }}>
      <Box sx={{ height: "100%" }} position="relative">
        <Box
          className="__back _cp fs-14"
          sx={{
            color: "var(--text-primary, #ffffff)",
            display: "flex",
            alignItems: "center",
            paddingLeft: "15px",
            paddingTop: "10px",
          }}
          onClick={() => history.goBack()}
        >
          <ArrowBackIosIcon
            className="fs-14"
            sx={{ color: "var(--text-primary, #ffffff)" }}
          />{" "}
          {t("back")}
        </Box>
        <img
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
          src={
            props["userData"]["coverImg"] &&
              props["userData"]["coverImg"]["filePath"] != ""
              ? props["userData"]["coverImg"]["filePath"]
              : cover
          }
          alt="cover"
        />
      </Box>

      {/* <Stack direction="row" spacing={1}>
        {history.location.pathname.includes(
          "/app/ArtistProfile/"
        ) ? null : upload ? (
          <Stack direction="row" className="_upload_video _upload_video_box">
            <OutlinedInput
              value={videoUrl}
              onChange={(e) => setVideoUrl(e.target.value)}
              sx={{ position: "relative" }}
              placeholder="Enter youtube video URL"
              multiline
              maxRows={2}
              endAdornment={
                <InputAdornment
                  sx={{ position: "absolute", right: "-6px" }}
                  position="start"
                  title="upload"
                >
                  <Button
                    onClick={handleUpload}
                    color="primary"
                    variant="contained"
                    className="fs-14"
                    startIcon={
                      videoLoader ? (
                        <CircularProgress
                          sx={{
                            width: "20px !important",
                            height: "20px !important",
                          }}
                          color="secondary"
                        />
                      ) : null
                    }
                  >
                    {videoLoader ? "uploading" : "upload"}
                  </Button>
                </InputAdornment>
              }
            />
            <IconButton
              title="close upload video"
              onClick={() => {
                setVideoLoader(false);
                setVideoUrl("");
                setUpload(false);
                setUpload(false);
              }}
            >
              <CloseIcon className="error fs-18" />
            </IconButton>
          </Stack>
        ) : props["edit"] ? null : (
          <IconButton onClick={() => setUpload(true)} className="_upload_video">
            <UploadIcon color="primary" className="fs-18" />
          </IconButton>
        )}
      </Stack> */}
      {history.location.pathname.includes("/app/ArtistProfile/") ? (
        <Button
          className="__play_all _copy_artist"
          onClick={handleClick}
          sx={{
            width: "96px",
            height: "36px !important",
            fontSize: "12px !important",
            fontWeight: "400 !important",
          }}
          variant="outlined"
          startIcon={
            <IosShareIcon className="__play_all_play" color="inherit" />
          }
        >
          {t("nftDetail.detail.share")}
        </Button>
      ) : props["edit"] ? null : (
        <Button
          className="__play_all _copy_artist_edit"
          onClick={handleClick}
          sx={{
            width: "96px",
            height: "36px !important",
            fontSize: "12px !important",
            fontWeight: "400 !important",
          }}
          variant="outlined"
          startIcon={
            <IosShareIcon
              className="__play_all_play "
              color="inherit"
              sx={{ width: "14px" }}
            />
          }
        >
          {t("nftDetail.detail.share")}
        </Button>
      )}
      {option ? (
        <OutsideClickHandler
          onOutsideClick={() => {
            handleClose();
          }}
        >
          <ProfileMenu
            right={
              history.location.pathname.includes("/app/ArtistProfile/")
                ? "0px !important"
                : "137px !important"
            }
            isHeader={true}
            isLast={"78px !important"}
            actions={[
              { key: "m14", action: t("dropMenu.m14") },
              { key: "m15", action: t("dropMenu.m15") },
              { key: "m16", action: t("dropMenu.m16") },
              // "Share on Instagram",
            ]}
            handleProfileMenuChoice={(action) => (handleCopy(action), handleClose())}
          />
        </OutsideClickHandler>
      ) : null}
      {props["edit"] ? (
        <IconButton
          onClick={() => onFileChooser("coverImg")}
          sx={{
            position: "absolute",
            top: -28,
            right: 10,
            bottom: 0,
            margin: "auto",
            width: 40,
            height: 40,
            backgroundColor: "var(--accent-color, #4C3E58)",
          }}
        >
          <input
            type="file"
            style={{ display: "none" }}
            id="coverImg"
            onChange={(e) => onFileSelect(e, "coverImg")}
            required
          />
          <Camera set="light" primaryColor="white" />
        </IconButton>
      ) : null}

      {props["isArtist"] && !props.loader ? (
        <Box
          sx={{
            width: "123px",
            height: "122px",
            position: "absolute",
            zIndex: "0",
            // top: "66%",
            left: "50.5%",
            backgroundColor: "transparent",
            padding: "4px 6px 6px 4px",
            transform: "translate(-50%, -50%)",
          }}
        >
          <HexagonalProgress
            progress={props["userData"]["percentage"]}
            style={{ position: "relative" }}
          />
          <img
            style={{
              zIndex: -20,
              objectFit: "cover",
              position: "absolute",
              width: "104px",
              height: "91px",
              top: "12px",
              left: "11px",
              border: "1px solid var(--text-primary, #000000)",
              clipPath:
                "polygon(25% 0%, 75% 0%, 100% 50%, 75% 99%, 25% 99%, 0% 50%)",
              backgroundColor: "var(--paper-color, #1e1e1e)",
            }}
            src={
              props["userData"]["profileImg"] &&
                props["userData"]["profileImg"]["filePath"] != ""
                ? props["userData"]["profileImg"]["filePath"]
                : image
            }
            alt="user"
          />
          <div
            onClick={() => {
              if (isOwnerId(props["userData"]["_id"])) {
                history.push(`/app/Leaderboard`);
              }
            }}
          >
            <div style={{ position: "absolute", top: "34px", right: "7px" }}>
              <div className="yellow-hex" style={{ position: "relative" }}>
                <div className="yellow-hex-inner"></div>
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                top: "36px",
                right: "9.5px",
              }}
            >
              <div className="black-hex">
                <div
                  className="black-hex-inner"
                  style={{ cursor: "default" }}
                ></div>
              </div>
            </div>
            <Box sx={{ position: "absolute", top: "71.5px", right: "23px" }}>
              <Typography
                align="center"
                fontWeight="bold"
                sx={{
                  color: "var(--primary-color, #FFEE20)",
                  cursor: isOwnerId(props["userData"]["_id"]) ? "pointer" : "",
                }}
              >
                {props["userData"]["avgLevel"]}
              </Typography>
            </Box>
          </div>
          {/* <Box
            sx={{
              position: "absolute",
              right: 10,
              bottom: 25,
              padding: "2px 1px 0px 1px",
              clipPath:
                "polygon(25% 2%, 75% 2%, 100% 50%, 75% 99%, 25% 99%, 0% 50%)",
              backgroundColor: "yellow",
              borderRadius: "5px",
              zIndex: "2",
            }}
          >
            <Box
              sx={{
                width: 35,
                paddingTop: "4px",
                clipPath:
                  "polygon(25% 2%, 75% 2%, 97% 48%, 75% 94%, 25% 94%, 3% 45%)",
                height: 30,
                backgroundColor: "black",
              }}
            >
              <Typography
                align="center"
                fontWeight="bold"
                sx={{ fontSize: "15px", color: "yellow" }}
              >
                {props["  "]["avgLevel"]}
              </Typography>
            </Box>
          </Box> */}
        </Box>
      ) : (
        <Box className="el">
          <Box>
            <HexagonalProgress
              progress={props["userData"]["percentage"]}
              style={{ position: "relative" }}
            />
            <img
              onClick={() => {
                if (isOwnerId(props["userData"]["_id"])) {
                  history.push(`/app/Leaderboard`);
                }
              }}
              style={{
                zIndex: -20,
                objectFit: "cover",
                position: "absolute",
                width: "104px",
                height: "91px",
                top: "12px",
                left: "11px",
                border: "1px solid var(--text-primary, #000000)",
                clipPath:
                  "polygon(25% 0%, 75% 0%, 100% 50%, 75% 99%, 25% 99%, 0% 50%)",
                backgroundColor: "var(--paper-color, #1e1e1e)",
              }}
              src={
                props["userData"]["profileImg"] &&
                  props["userData"]["profileImg"]["filePath"] != ""
                  ? props["userData"]["profileImg"]["filePath"]
                  : image
              }
              alt="user"
            />
            {props["edit"] ? (
              <div>
                <div
                  style={{ position: "absolute", top: "34px", right: "3px" }}
                >
                  <div className="yellow-hex" style={{ position: "relative" }}>
                    <div className="yellow-hex-inner"></div>
                  </div>
                </div>
                <div
                  style={{
                    position: "absolute",
                    top: "36px",
                    right: "5.5px",
                  }}
                >
                  <div className="grey-hex">
                    <div className="grey-hex-inner"></div>
                  </div>
                </div>
                <Box sx={{ position: "absolute", top: "62.5px", right: "3px" }}>
                  <IconButton onClick={() => onFileChooser("profileImg")}>
                    <Camera set="light" primaryColor="white" />
                    <input
                      type="file"
                      style={{ display: "none" }}
                      id="profileImg"
                      onChange={(e) => onFileSelect(e, "profileImg")}
                      required
                    />
                  </IconButton>
                </Box>
              </div>
            ) : (
              <div
                onClick={() => {
                  if (isOwnerId(props["userData"]["_id"])) {
                    history.push(`/app/Leaderboard`);
                  }
                }}
              >
                <div
                  style={{ position: "absolute", top: "34px", right: "3px" }}
                >
                  <div className="yellow-hex" style={{ position: "relative" }}>
                    <div className="yellow-hex-inner"></div>
                  </div>
                </div>
                <div
                  style={{
                    position: "absolute",
                    top: "36px",
                    right: "5.5px",
                  }}
                >
                  <div className="black-hex">
                    <div className="black-hex-inner"></div>
                  </div>
                </div>
                <Box
                  sx={{ position: "absolute", top: "71.5px", right: "18px" }}
                >
                  <Typography
                    align="center"
                    fontWeight="bold"
                    sx={{
                      color: "var(--primary-color, #FFEE20)",
                      cursor: isOwnerId(props["userData"]["_id"])
                        ? "pointer"
                        : "",
                    }}
                  >
                    {props["userData"]["avgLevel"]}
                  </Typography>
                </Box>
              </div>
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
}
